var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgIcFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 42,
    viewBox: "0 0 33 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.123 11.8125V36.75C32.123 38.1424 31.5699 39.4777 30.5854 40.4623C29.6008 41.4469 28.2654 42 26.873 42H5.87305C4.48066 42 3.1453 41.4469 2.16074 40.4623C1.17617 39.4777 0.623047 38.1424 0.623047 36.75V5.25C0.623047 3.85761 1.17617 2.52226 2.16074 1.53769C3.1453 0.553123 4.48066 0 5.87305 0L20.3105 0L32.123 11.8125ZM24.248 11.8125C23.2038 11.8125 22.2022 11.3977 21.4638 10.6592C20.7254 9.92081 20.3105 8.91929 20.3105 7.875V2.625H5.87305C5.17685 2.625 4.50917 2.90156 4.01689 3.39384C3.52461 3.88613 3.24805 4.55381 3.24805 5.25V36.75C3.24805 37.4462 3.52461 38.1139 4.01689 38.6062C4.50917 39.0984 5.17685 39.375 5.87305 39.375H26.873C27.5692 39.375 28.2369 39.0984 28.7292 38.6062C29.2215 38.1139 29.498 37.4462 29.498 36.75V11.8125H24.248Z",
    fill: "#767676"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFiles);
export default __webpack_public_path__ + "static/media/icFiles.097b9ab12b1b99a34079158c8dadbbba.svg";
export { ForwardRef as ReactComponent };